import styled from 'styled-components';
import AntdModal from '../../../AntdModal';
import {typographyStyles} from '../../../../utils/styles';

const StyledApprovalModal = styled(AntdModal)`
  .ant-modal-content {
    .ant-modal-body {
      ${typographyStyles.body.regular};
    }
    .ant-modal-footer {
      display: flex;
      justify-content: flex-end;
      .ant-btn {
        .ant-btn-icon {
          display: flex;
        }
        &:disabled {
          svg {
            path {
              fill: rgba(0,0,0,0.25);
            }
          }
        }
        svg {
          path {
            fill: ${props => props.theme.colors.neutral_1};
          }
        }
      }
    }
  }
`;

export {
  StyledApprovalModal
};
